import { ref } from 'vue';
import { POSITION, useToast } from "vue-toastification";
import lang from "./translate/lang.js";

const isConnected = ref(false); // 是否已连接signalr
const layer = layui.layer;
layer.config({
	skin: 'layui-layer-custom',
	//lang: 'us-en'
});
const util = layui.util;

const currentProduct = ref(null);

const mainWallet = ref(null);

const userInfo = ref(null);
const userDetail = ref(null);

const isMobile = ref(false);
const isToss = ref(false);
const bottomNavValue = ref(2);
const overlay = ref(false);
const chartDialog = ref(false);
const mableSymbol = ref('');
const timeType = ref('minute5');

const toast = useToast();
const showToast = (message, type, timeout) => {
	toast(
		message,
		{
			position: POSITION.BOTTOM_RIGHT,// "bottom-right",
			type: type,
			timeout: timeout			 
		}
	);
}
let locale = ref('ko');

const translate = (key, params = {}) => {
	var text = '';

	const entry = lang[key];
	if (!entry) return key;

	
	if (locale.value == 'ko' || locale.value == 'ko-kr') {
		text = lang[key].ko;
	}
	else {
		text = lang[key].en;
	}

	return text.replace(/\{(\w+)\}/g, (_, k) =>
		params[k] ?? ''
	);
};

export {
	isConnected,
	layer,
	util,
	bottomNavValue,
	currentProduct,
	mainWallet,
	userInfo,
	userDetail,
	isMobile,
	isToss,
	overlay, 
	chartDialog, 
	mableSymbol, 
	timeType, 
	showToast,
	locale,
	translate,
};

var enumServiceType;
var enumPriceKind;
var enumMoneyIOKind;
var enumMoneyIOStatus;
var enumOrderSide;
var enumOrderPath;
var enumOrderKind;
var enumOrderStatus;
var enumPositionStatus;
var enumMitStatus;
var enumStockLimitType;

var orderUpdateQueue = [];
var positionUpdateQueue = [];

(function (enumPriceKind) {
	enumPriceKind[(enumPriceKind['LimitOrder'] = 0)] = '지정가';
	enumPriceKind[(enumPriceKind['MarketOrder'] = 1)] = '시장가';
	enumPriceKind[(enumPriceKind['MarketAmount'] = 2)] = '금액주문';
})(enumPriceKind || (enumPriceKind = {}));
(function (enumServiceType) {
	enumServiceType[(enumServiceType['NONE'] = 0)] = 'NONE';
	enumServiceType[(enumServiceType['STOCK'] = 1)] = 'STOCK';
	enumServiceType[(enumServiceType['COIN'] = 2)] = 'COIN';
	enumServiceType[(enumServiceType['HORSE'] = 3)] = 'HORSE';
	enumServiceType[(enumServiceType['SPORTS'] = 4)] = 'SPORTS';
	enumServiceType[(enumServiceType['GAMBLE'] = 5)] = 'GAMBLE';
	enumServiceType[(enumServiceType['FX'] = 6)] = 'FX';
	enumServiceType[(enumServiceType['MINIGAME'] = 7)] = 'MINIGAME';
	enumServiceType[(enumServiceType['ETC'] = 8)] = 'ETC';
})(enumServiceType || (enumServiceType = {}));
// moneyio
(function (enumMoneyIOKind) {
	enumMoneyIOKind[(enumMoneyIOKind['Deposit'] = 0)] = '입금';
	enumMoneyIOKind[(enumMoneyIOKind['Withdraw'] = 1)] = '출금';
	enumMoneyIOKind[(enumMoneyIOKind['DepositAdmin'] = 2)] = '입금';
	enumMoneyIOKind[(enumMoneyIOKind['WithdrawAdmin'] = 3)] = '출금';
	enumMoneyIOKind[(enumMoneyIOKind['ChargeCash'] = 4)] = '현금보상';
	enumMoneyIOKind[(enumMoneyIOKind['ChargeBonus'] = 5)] = '지원금지급';
	enumMoneyIOKind[(enumMoneyIOKind['RecycleCash'] = 6)] = '본사회수';
	enumMoneyIOKind[(enumMoneyIOKind['RecycleBonus'] = 7)] = '본사회수';
	enumMoneyIOKind[(enumMoneyIOKind['DepositBonus'] = 8)] = '지원금지급';
	enumMoneyIOKind[(enumMoneyIOKind['RecycleMargin'] = 9)] = '본사회수';
})(enumMoneyIOKind || (enumMoneyIOKind = {}));
(function (enumMoneyIOStatus) {
	enumMoneyIOStatus[(enumMoneyIOStatus['Request'] = 0)] = '신청';
	enumMoneyIOStatus[(enumMoneyIOStatus['Accept'] = 1)] = '승인';
	enumMoneyIOStatus[(enumMoneyIOStatus['Reject'] = 2)] = '거절';
	enumMoneyIOStatus[(enumMoneyIOStatus['WaitConfirm'] = 3)] = '대기';
})(enumMoneyIOStatus || (enumMoneyIOStatus = {}));
//order
(function (enumOrderSide) {
	enumOrderSide[(enumOrderSide['Buy'] = 0)] = '매수';
	enumOrderSide[(enumOrderSide['Sell'] = 1)] = '매도';
})(enumOrderSide || (enumOrderSide = {}));
(function (enumOrderPath) {
	enumOrderPath[(enumOrderPath['User'] = 0)] = '유저';
	enumOrderPath[(enumOrderPath['Admin'] = 1)] = '관리자';
	enumOrderPath[(enumOrderPath['Losscut'] = 2)] = '로스컷';
	enumOrderPath[(enumOrderPath['DayEnd'] = 3)] = '마감주문';
	enumOrderPath[(enumOrderPath['OverExp'] = 4)] = '기간만료';
	enumOrderPath[(enumOrderPath['CSOrder'] = 5)] = 'CS주문';
	enumOrderPath[(enumOrderPath['OverMarginCut'] = 6)] = '금액부족';
	enumOrderPath[(enumOrderPath['OverProdCut'] = 7)] = '오버제한';
	enumOrderPath[(enumOrderPath['MIT'] = 8)] = '예약주문';
})(enumOrderPath || (enumOrderPath = {}));
(function (enumOrderKind) {
	enumOrderKind[(enumOrderKind['NewOrder'] = 0)] = '신규주문';
	enumOrderKind[(enumOrderKind['CancelOrder'] = 1)] = '취소주문';
	enumOrderKind[(enumOrderKind['MoveOrder'] = 2)] = '정정주문';
	enumOrderKind[(enumOrderKind['Fill'] = 3)] = '체결';
})(enumOrderKind || (enumOrderKind = {}));
(function (enumOrderStatus) {
	enumOrderStatus[(enumOrderStatus['Open'] = 0)] = '대기';
	enumOrderStatus[(enumOrderStatus['Working'] = 1)] = '체결중';
	enumOrderStatus[(enumOrderStatus['Move'] = 2)] = '정정';
	enumOrderStatus[(enumOrderStatus['Cancel'] = 3)] = '취소';
	enumOrderStatus[(enumOrderStatus['Finish'] = 4)] = '완료';
})(enumOrderStatus || (enumOrderStatus = {}));

(function (enumMitStatus) {
	enumMitStatus[(enumMitStatus['WAIT'] = 0)] = '대기';
	enumMitStatus[(enumMitStatus['MAKEORDER'] = 1)] = '주문성공';
	enumMitStatus[(enumMitStatus['FAILORDER'] = 2)] = '주문실패';
	enumMitStatus[(enumMitStatus['CANCEL'] = 3)] = '취소';
	enumMitStatus[(enumMitStatus['ADMINCANCEL'] = 4)] = '관리자취소';
})(enumMitStatus || (enumMitStatus = {}));
// filled
//POSITION, LIQUIDED
(function (enumPositionStatus) {
	enumPositionStatus[(enumPositionStatus['POSITION'] = 0)] = '잔고';
	enumPositionStatus[(enumPositionStatus['LIQUIDED'] = 1)] = '청산';
})(enumPositionStatus || (enumPositionStatus = {}));


(function (enumStockLimitType) {
	enumStockLimitType[(enumStockLimitType['보통주'] = 100)] = '보통주';
	enumStockLimitType[(enumStockLimitType['우선주'] = 101)] = '우선주';
	enumStockLimitType[(enumStockLimitType['동전주'] = 102)] = '동전주';
	enumStockLimitType[(enumStockLimitType['종목제한'] = 200)] = '종목제한';
	enumStockLimitType[(enumStockLimitType['종목제한'] = 250)] = '종목제한';
	enumStockLimitType[(enumStockLimitType['거래정지'] = 301)] = '거래정지';
	enumStockLimitType[(enumStockLimitType['정리매매'] = 302)] = '정리매매';
	enumStockLimitType[(enumStockLimitType['관리종목'] = 303)] = '관리종목';
	enumStockLimitType[(enumStockLimitType['투자환기'] = 304)] = '투자환기';
	enumStockLimitType[(enumStockLimitType['불성실'] = 305)] = '불성실';
	enumStockLimitType[(enumStockLimitType['단일가'] = 306)] = '단일가';
	enumStockLimitType[(enumStockLimitType['주식부족'] = 307)] = '주식부족';
	enumStockLimitType[(enumStockLimitType['단기과열'] = 308)] = '단기과열';
	enumStockLimitType[(enumStockLimitType['투자주의'] = 309)] = '투자주의';
	enumStockLimitType[(enumStockLimitType['투자경고'] = 310)] = '투자경고';
	enumStockLimitType[(enumStockLimitType['투자위험'] = 311)] = '투자위험';
	enumStockLimitType[(enumStockLimitType['외국증권'] = 400)] = '외국증권';
	enumStockLimitType[(enumStockLimitType['ETF'] = 500)] = 'ETF';
})(enumStockLimitType || (enumStockLimitType = {}));

const tradePassword = ref('');

export {
	enumPriceKind,
	enumMoneyIOKind,
	enumMoneyIOStatus,
	enumServiceType,
	enumOrderSide,
	enumOrderPath,
	enumOrderKind,
	enumOrderStatus,
	enumPositionStatus,
	enumMitStatus,
	enumStockLimitType,
	orderUpdateQueue,
	positionUpdateQueue,
	tradePassword
};
